import React from 'react';
import { PRIORITY_COLORS, CRITICALITY_COLORS } from '../../utils/constants';
import { formatDate } from '../../utils/dates';
import Badge from '../shared/Badge';

function CriticalTasksList({ tasks = [], onEntryClick }) {
  if (!tasks.length) return <div className="list-empty">Sin tareas críticas pendientes</div>;
  return (
    <div className="item-list">
      {tasks.map(t => (
        <div
          key={t.id}
          className="item-row clickable"
          onClick={() => t.entry_id && onEntryClick?.(t.entry_id)}
          style={{ cursor: t.entry_id ? 'pointer' : 'default' }}
        >
          <span className="priority-dot" style={{ background: PRIORITY_COLORS[t.priority] }} />
          <div className="item-row__main">
            <span className="item-row__title">{t.title}</span>
            <div className="item-row__meta">
              <Badge label={t.criticality} color={CRITICALITY_COLORS[t.criticality]} />
              {t.due_date && <span className="meta-chip">📅 {formatDate(t.due_date)}</span>}
              {t.risk_count > 0 && <span className="meta-chip danger">⚠ {t.risk_count}</span>}
              {t.entry_id && <span className="meta-chip" style={{ color: 'var(--accent)' }}>Ver predicado →</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CriticalTasksList;
